import axios from "@/utils/axiosHelper";

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios(
    { url: "/cherry/collect/init", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取奖励
export const reward = (params) => {
  return axios(
    { url: "/cherry/collect/reward", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 生成赠送/交换卡片
export const generateCode = (data) => {
  return axios(
    { url: "/cherry/collect/code", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 获取祈愿或者交换或者赠与链接状态
export const cherryStatus = (data) => {
  return axios(
    { url: "/cherry/collect/card", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 通过赠送链接赠送道具
export const receive = (data) => {
  return axios(
    { url: "/cherry/collect/receive", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 交换卡片
export const exchange = (data) => {
  return axios(
    { url: "/cherry/collect/exchange", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 祈愿赠与道具
export const generateGave = (data) => {
  return axios(
    { url: "/cherry/collect/gave", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 抽奖
export const lotteryApi = (data) => {
  return axios(
    { url: "/cherry/collect/lottery", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 填写收货地址
export const addressApi = (data) => {
  return axios(
    { url: "/cherry/collect/address", method: "POST", data },
    { interceptResultCode: false }
  );
};

// 获取渠道用户角色信息
export const getRoleDataAPI = (params) => {
  return axios(
    { url: "/cherry/collect/role", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 免密登录
export const secretFreeLoginApi = (data) => {
  return axios(
    { url: "/cherry/auth/login", method: "POST", data },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/sakura/sanliouLinkage/api.js